import { render, staticRenderFns } from "./agentDetail.vue?vue&type=template&id=2a06ec70&scoped=true&"
import script from "./agentDetail.vue?vue&type=script&lang=js&"
export * from "./agentDetail.vue?vue&type=script&lang=js&"
import style0 from "./agentDetail.vue?vue&type=style&index=0&id=2a06ec70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06ec70",
  null
  
)

export default component.exports